import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@heidi/design-system/alert-dialog';
import { FormattedMessage } from 'react-intl';

export interface SwitchWhileRecordingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Explains a refused workspace switch while a recording is active. Switching
 * re-stamps every request with the new workspace, and on desktop the native
 * recorder outlives the document, so a recording in flight would have its
 * remaining uploads misattributed — the user ends the recording through the
 * recording UI first, then switches.
 *
 * Action-triggered, so a standalone dialog rather than a queued modal. The
 * decision that a recording is active stays app-side, where the recording
 * state lives; this component only explains.
 */
export const SwitchWhileRecordingDialog = ({
  open,
  onOpenChange,
}: SwitchWhileRecordingDialogProps) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="switch-while-recording-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>
          <FormattedMessage defaultMessage="Session in progress" id="tAVet8BKFu" />
        </AlertDialogTitle>
        <AlertDialogDescription>
          <FormattedMessage
            defaultMessage="End your recording before switching workspace."
            id="7zIgi5ZIZ/"
          />
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="switch-while-recording-close">
          <FormattedMessage defaultMessage="OK" id="kAEQyVFWDv" />
        </AlertDialogCancel>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
